import {observer} from "mobx-react-lite"
import React, {Fragment} from "react"
import valueOutput from "../../store/entities/ValueOutput"
import {AsyncAdaptersSelection} from "../AsyncAdapterSelection"
import "../rule/destination.sass"
import {DestinationDescription} from "./DestinationDescription"
import {Field} from "../../lib/wa-2.0"

export const DestinationComponent = observer(({destination}: { destination: valueOutput }) => {
    const fieldLabel = (
        <span className={(destination.label === 'Название' || destination.label === 'Артикул') ? 'custom-pl-16':''}>
            {destination.label} {destination.isRequired && <span style={{color: "var(--red)"}}>*</span>}
            <DestinationDescription destination={destination}/>
        </span>
    )

    return <Fragment>
        <Field classes={["custom-my-8", "attr-field"]} label={fieldLabel}>
            <div className={'flexbox middle'}>
                <div className={'custom-mr-8'}>
                    <i className="fa fa-arrow-right" aria-hidden="true"/>
                </div>
                <div className="width-40">
                    <AsyncAdaptersSelection destination={destination}/>
                </div>
                <div className="custom-ml-4">
                    {destination.additional}
                </div>
            </div>
        </Field>
    </Fragment>
})